import * as ActionTypes from 'state/actions/types'

export const interactionsChangeField = (field, value) => {
  return {
    type: ActionTypes.INTERACTIONS_CHANGE_FIELD,
    field,
    value
  }
}

export const interactionsChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.INTERACTIONS_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const interactionsMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.INTERACTIONS_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
